import LinkToDocusaurus from '../LinkToDocusaurus'
import { Color, Paragraph } from '@eggplant/pattern-library'
import { runner } from '../../docs-routes'

const RunSelectedStepsExcludeDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      If a step is captured by both include and exclude filters, exclusion takes a higher priority than inclusion.
    </Color>
    <br />
    <br />
    <Paragraph>
      <LinkToDocusaurus path={runner}>Learn more in the DAI documentation</LinkToDocusaurus>
    </Paragraph>
  </Paragraph>

export default RunSelectedStepsExcludeDescription
